import React, { useEffect } from "react";
import Nav from "./components/Nav";
import Kinds from "./components/kinds";
import Footer from "./components/Footer";
import FloatingIcons from "./components/FloatingIcons";

const KindPage = () => {

  return (
    <>
      <Nav />
      <FloatingIcons />
      <div style={{ paddingTop: "50px" }}>
        <Kinds />
      </div>
      <Footer />
    </>
  );
};

export default KindPage;
